import React, { useState } from 'react'
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';

const createOption = (label) => ({
  label,
  value: label,
});

export const PageviewFields = (props) => {
  const [ inputError, setInputError ] = useState({filter: false, condition: false, value: false});
  const [ selectedValues, setSelectedValues ] = useState({inputValue: "", value: []});

  const handleChange = ({value}, key) => {
    const arr = props.localData.trigger ? props.localData.trigger : [];
    props.setLocalData({...props.localData, trigger: {...arr, [key]: value}});
  }

  const handleInputChange = inputValue => setSelectedValues({...selectedValues, inputValue});
  
  const handleChangeValue = value => {
    setSelectedValues({...selectedValues, value});
    
    if ( value && value.length !== 0 ) {
      const arr = props.localData.trigger ? props.localData.trigger : [];
      delete arr.value;

      arr.value = [];

      value.map(item => {
        arr.value.push(item.value);
      });
      props.setLocalData({...props.localData, trigger: arr});
    }
  }

  const handleKeyDown = (event) => {
    const { key, nativeEvent } = event;
    const { inputValue, value } = selectedValues;
    if ( !inputValue ) return;

    setInputError({...inputError, value: false});

    switch ( key ) {
      case ";":
      case "Enter":
      case "Tab":
      case "Blur":
        event.preventDefault();

        setSelectedValues({
          inputValue: "",
          value: (value && value.length !== 0) ? [...value, createOption(inputValue)] : [createOption(inputValue)]
        });

        const arr = props.localData.trigger ? props.localData.trigger : [];
        if ( !arr.value ) arr.value = [];
        arr.value.push(inputValue);
        props.setLocalData({...props.localData, trigger: arr});
      break;
      default: break;
    }
  }

  return (
    <>
      <div className="titled__group">
        <p>Condição:</p>
        <Select
          options={[
            {label: "Igual a", value: "=="},
            {label: "Diferente de", value: "!="},
            {label: "Contém", value: "contain"},
            {label: "Não contém", value: "notcontain"}
          ]}
          className="basic-select"
          classNamePrefix="select"
          placeholder="Selecione a condição"
          onChange={(e) => handleChange(e, "comparation")}
        />
      </div>
      <div className="titled__group">
        <p>Valores:</p>
        <CreatableSelect
          className="basic-select"
          components={{DropdownIndicator: null}}
          inputValue={selectedValues.inputValue}
          isClearable
          isMulti
          menuIsOpen={false}
          onChange={handleChangeValue}
          onInputChange={handleInputChange}
          onKeyDown={handleKeyDown}
          placeholder="Defina as URLs"
          value={selectedValues.value}
        />
        {
          inputError.value ?
            <p className="input__text--error">Informe uma URL válida. (Ex.: https://site.com)</p>
          : null
        }
      </div>
    </>
  )
}